import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#FF6699'];

const DETAIL_COLORS = ['#6FE15E', '#FF5D47'];

// Priprema podataka za detalje
const renderInnerLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  value,
  name,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  const textAnchor = x > cx ? 'start' : 'end';

  const cos = Math.cos(-midAngle * RADIAN);
  const sin = Math.sin(-midAngle * RADIAN);
  let textX = x;
  let textY = y;

  // Adjust the position based on the angle
  if (midAngle > 90 && midAngle <= 270) {
    textX += -70 * cos;
    textY += -5 * sin;
  } else {
    textX += -60 * cos;
    textY += 10 * sin;
  }

  return (
    <text
      x={textX}
      y={textY}
      fill="black"
      textAnchor={textAnchor}
      dominantBaseline="central"
      style={{ fontSize: '12px', fontWeight: '600' }}
    >
      {`${name} ${value}`}
    </text>
  );
};

const renderOuterLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  value,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="black"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      style={{ fontSize: '12px', fontWeight: '600' }}
    >
      {`${value}`}
    </text>
  );
};

const ChartPie = ({ data }) => {
  const detailData = data.flatMap((item) => [
    {
      name: `${item.imeZaposlenog} Usluge`,
      value: item.dobitZaposleniUsl,
      color: DETAIL_COLORS[1],
    },
    {
      name: `${item.imeZaposlenog} Transport`,
      value: item.dobitZaposleniTr,
      color: DETAIL_COLORS[0],
    },
  ]);

  const legendData = [
    { value: 'Usluge', color: DETAIL_COLORS[1] },
    { value: 'Transport', color: DETAIL_COLORS[0] },
  ];

  return (
    <div style={{ width: '600px', display: 'flex', justifyContent: 'start' }}>
      <PieChart width={550} height={450}>
        <Pie
          data={data}
          cx={275}
          cy={225}
          innerRadius={0}
          outerRadius={150}
          fill="#8884d8"
          dataKey="ukupno"
          labelLine={false}
          label={renderInnerLabel}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={COLORS[index % COLORS.length]}
              name={entry.imeZaposlenog}
            />
          ))}
        </Pie>
        <Pie
          data={detailData}
          cx={275}
          cy={225}
          innerRadius={170}
          outerRadius={210}
          fill="#82ca9d"
          dataKey="value"
          labelLine={false}
          label={renderOuterLabel}
        >
          {detailData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip />
        <Legend
          layout="vertical"
          align="right"
          verticalAlign="top"
          payload={legendData.map((entry) => ({
            value: entry.value,
            type: 'square',
            color: entry.color,
          }))}
        />
      </PieChart>
    </div>
  );
};

export default ChartPie;
